// Match the subject before the module, so a payment opened from a project
// looks like a payment and a conversation opened from scheduling looks like a conversation.
const subjects = [
  ['warning', /^(?:delete|remove|void|block)\b/i],
  [
    'finance',
    /\b(?:bills?|invoices?|payments?|payouts?|discounts?|collect|estimates?|checks?)\b/i,
  ],
  [
    'documents',
    /\b(?:contracts?|documents?|templates?|agreements?|attachments?|sign(?:ers?|ing|atures?)?|authorization|disclosure|visit summary)\b/i,
  ],
  ['legal', /\b(?:legal|liens?|lawsuits?|complaints?|claims?)\b/i],
  [
    'schedule',
    /\b(?:scheduled?|calendar|dispatch|on call|time off|routes?|crews?|visits?)\b/i,
  ],
  ['reports', /\b(?:reports?|stats|analytics)\b/i],
  [
    'messages',
    /\b(?:messages?|emails?|conversations?|calls?|dialer|phone|repl(?:y|ies)|transcribe|comms|notifications?|tracking|inquir(?:y|ies))\b/i,
  ],
  ['campaigns', /\b(?:campaigns?|blasts?|sources?)\b/i],
  [
    'people',
    /\b(?:customers?|adjusters?|leads?|contacts?|users?|account|password|collaborators?|recipients?|insurance companies)\b/i,
  ],
  ['tasks', /\b(?:tasks?|notes?|stages?|pipeline)\b/i],
  ['house', /\b(?:projects?|restoration|job types?|trades?)\b/i],
  [
    'settings',
    /\b(?:setup|settings|configuration|organization|flows?|labels?|tags?|tabs?|statuses?|synonyms?|prompts?)\b/i,
  ],
] as const

export function subjectScene(subject: string) {
  return subjects.find(([, pattern]) => pattern.test(subject))?.[0]
}

export function pageScene(path: string) {
  const [pathname = '', query] = path.split('#')[0]!.split('?')
  const [area = '', page = ''] = pathname.split('/').filter(Boolean)
  if (
    area === 'leads' &&
    !page &&
    new URLSearchParams(query).get('stage') === 'estimate'
  )
    return 'finance'
  return (
    subjectScene(page.replaceAll('-', ' ')) ??
    subjectScene(area) ??
    (area === 'scheduling' ? 'schedule' : area === 'crm' ? 'people' : 'house')
  )
}
